/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { ZoomLatLonDialogComponent } from './zoom-lat-lon-dialog.component';
import { ZOOM_LAT_LON_COMMAND } from './zoom-lat-lon.token';
import { zoomLatLonFactory } from './zoom-lat-lon.factory';
import { ZoomLatLonService } from './zoom-lat-lon.service';


@NgModule({
    declarations: [
        ZoomLatLonDialogComponent,
    ],
    imports: [
        SharedModule,
    ],
    providers: [
        ZoomLatLonService,
        { provide: ZOOM_LAT_LON_COMMAND, useFactory: zoomLatLonFactory },
    ]
})
export class ZoomLatLonModule {}
